import { SegmentedControls } from './SegmentedControls';

export const DataVariantSelector = ({
    onClick,
    currentDataVariant,
}: {
    onClick: (dataVariant: DataVariant) => void;
    currentDataVariant: DataVariant;
}) => {
    return (
        <SegmentedControls
            onClick={onClick}
            selectedValue={currentDataVariant}
            options={[
                { value: 'report', label: 'Report' },
                { value: 'preTrade', label: 'Pre-Trade' },
            ]}
        />
    );
};
